<template>
  <v-dialog
    v-model="isOpen"
    max-width="790"
    width="530"
    :persistent="true"
    @keydown.prevent.enter="executeMainAction"
  >
    <v-card class="dialog-box">
      <v-card-title class="headline">
        {{ $tc("TechnicalPoint", 1) }}
      </v-card-title>

      <v-card-text style="padding-bottom: 10px; white-space: normal">
        <div>{{ $t("SelectOption") }}</div>
      </v-card-text>
      <treeselect
        v-model="technicalPoint"
        :options="technicalPointOptions"
        class="select-tech-point ml-4"
        :clearable="false"
      />

      <v-card-actions>
        <v-btn
          @click="executeSecondaryAction"
          :ripple="false"
          class="secondary-button"
          text
        >
          {{ $t("Cancel") }}
        </v-btn>
        <v-btn
          @click="executeMainAction"
          :ripple="false"
          class="main-button"
          text
        >
          {{ $t("Select") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogBulkTechPointType",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isOpen: false,
      technicalPoint: "fc_pole"
    };
  },

  computed: {
    /**
     * Returns the technical point options
     */
    technicalPointOptions() {
      return [
        {
          label: this.$i18n.tc("Pole", 1),
          id: "fc_pole"
        },
        {
          label: this.$i18n.tc("Manhole", 1),
          id: "fc_manhole"
        },
        {
          label: this.$i18n.tc("Toby Box", 1),
          id: "fc_toby_box"
        }
      ];
    }
  },

  watch: {
    /**
     * Wathces for changes in the open variable and assigns the new value to the isOpen variable
     *
     * @param {Boolean} newValue - the value indicating if the window is open or not
     */
    open(newValue) {
      this.isOpen = newValue;
    }
  },

  methods: {
    /**
     * Send an event to the parent to execute the main action.
     */
    executeMainAction() {
      this.$emit("selectedTechPoint", this.technicalPoint);
    },
    /**
     * Send an event to the parent to execute the secondary action.
     */
    executeSecondaryAction() {
      this.$emit("cancelCreation");
    }
  }
};
</script>

<style scoped>
.select-tech-point {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 11px;
  text-align: left;
  margin-bottom: 20px;
  position: relative;
}

.v-dialog__content >>> .v-dialog {
  overflow-y: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogBulkTechPointType.vue